import { defineMessages } from 'react-intl';

const translationsUI = defineMessages({
  DEVICE_LANGUAGE: {
    id: 'DEVICE_LANGUAGE',
    defaultMessage: `Device language`,
  },
  SUBMITTING_UPDATED_DAMAGES: {
    id: 'SUBMITTING_UPDATED_DAMAGES',
    defaultMessage: 'Submitting updated damages...',
  },
  PRIVACY_PAVE: {
    id: 'PRIVACY_PAVE',
    defaultMessage: `privacy`,
  },
  CONTACT_SUPPORT: {
    id: 'CONTACT_SUPPORT',
    defaultMessage: `support`,
  },
  NAVBAR_COMING_UP_NEXT: {
    id: 'NAVBAR_COMING_UP_NEXT',
    defaultMessage: ` Coming Up Next`,
  },
  NAVBAR_NEXT_YOU_WILL: {
    id: 'NAVBAR_NEXT_YOU_WILL',
    defaultMessage: `Next you will`,
  },
  NAVBAR_COMING_NEXT_BTN: {
    id: 'NAVBAR_COMING_NEXT_BTN',
    defaultMessage: `next`,
  },
  LABEL_1: {
    id: 'LABEL_1',
    defaultMessage: `vin`,
  },
  VIN_DECODE_TITLE: {
    id: 'VIN_DECODE_TITLE',
    defaultMessage: `How would you like to proceed ?`,
  },
  VIN_DECODE_MANUAL_BTN: {
    id: 'VIN_DECODE_MANUAL_BTN',
    defaultMessage: `Manual`,
  },
  VIN_DECODE_CAPTURE_BTN: {
    id: 'VIN_DECODE_CAPTURE_BTN',
    defaultMessage: `capture`,
  },
  VIN_DECODE_INPUT_VIN: {
    id: 'VIN_DECODE_INPUT_VIN',
    defaultMessage: `Please Input the Vehicle's VIN`,
  },

  VIN_DECODE_INPUT_VIN_PIN_SERIAL: {
    id: 'VIN_DECODE_INPUT_VIN_PIN_SERIAL',
    defaultMessage: `Please Input the Vehicle's VIN, PIN or SERIAL`,
  },
  VIN_DECODE_OPS: {
    id: 'VIN_DECODE_OPS',
    defaultMessage: `oops`,
  },
  ADD_IMAGES_GALLERY_BTN_BACK: {
    id: 'ADD_IMAGES_GALLERY_BTN_BACK',
    defaultMessage: `back`,
  },
  VIN_DECODE_WRONG: {
    id: 'VIN_DECODE_WRONG',
    defaultMessage: `Incorrect VIN`,
  },
  VIN_DECODE_TROUBLE: {
    id: 'VIN_DECODE_TROUBLE',
    defaultMessage: `We're having trouble reading your VIN`,
  },
  HOME_PAVE_1: {
    id: 'HOME_PAVE_1',
    defaultMessage: `A better way to perform vehicle inspections.`,
  },
  HOME_PAVE_1_LITE: {
    id: 'HOME_PAVE_1_LITE',
    defaultMessage: `a better way to capture vehicles.`,
  },
  HOME_PAVE_2: {
    id: 'HOME_PAVE_2',
    defaultMessage: `Perform your trade-in inspection from home all on your phone`,
  },
  HOME_PAVE_2_LITE: {
    id: 'HOME_PAVE_2_LITE',
    defaultMessage: `Turn any phone into a lot capture tool in one click.`,
  },
  HOME_PAVE_6: {
    id: 'HOME_PAVE_6',
    defaultMessage: `Get Started`,
  },
  HOME_PAVE_6_RESUME: {
    id: 'HOME_PAVE_6_RESUME',
    defaultMessage: `resume`,
  },
  HOME_PAVE_7: {
    id: 'HOME_PAVE_7',
    defaultMessage: `Rotate Your Device (if locked please unlock in your device settings)`,
  },
  HOME_PAVE_3: {
    id: 'HOME_PAVE_3',
    defaultMessage: `how it works`,
  },
  HOME_PAVE_4: {
    id: 'HOME_PAVE_4',
    defaultMessage: `Simply go to your vehicle and park in a safe place that allows you to take clear photos from all angles. You should have clearance of 10 feet on all sides.`,
  },
  HOME_PAVE_5: {
    id: 'HOME_PAVE_5',
    defaultMessage: `When you're ready, rotate your device and click Get Started.`,
  },
  PAVE_1: {
    id: 'PAVE_1',
    defaultMessage: `pave`,
  },
  PAVE__LOADING_SNINNER_2: {
    id: 'PAVE__LOADING_SNINNER_2',
    defaultMessage: `Is Working Hard.`,
  },
  HEADER_VHICLE_DATA_INFO: {
    id: 'HEADER_VHICLE_DATA_INFO',
    defaultMessage: `Vehicle Data`,
  },
  HEADER_SELECT_LANGUAGES: {
    id: 'HEADER_SELECT_LANGUAGES',
    defaultMessage: `Select Languages`,
  },
  ODOM_READING_MESSAGE: {
    id: 'ODOM_READING_MESSAGE',
    defaultMessage: `we're having trouble reading your Odometer`,
  },
  ODOM_READING_BTN: {
    id: 'ODOM_READING_BTN',
    defaultMessage: `Submit`,
  },
  ODOM_READING_MESSAGE_ERROR_1: {
    id: 'ODOM_READING_MESSAGE_ERROR_1',
    defaultMessage: `Odometer must be filled out`,
  },
  ODOM_READING_MESSAGE_ERROR_2: {
    id: 'ODOM_READING_MESSAGE_ERROR_2',
    defaultMessage: `Odom Unit must be filled out`,
  },
  ODOM_READING_INPUT_FROM_CAM: {
    id: 'ODOM_READING_INPUT_FROM_CAM',
    defaultMessage: `Please input your odometers below`,
  },
  GALLERY_IMAGES_REPORT: {
    id: 'GALLERY_IMAGES_REPORT',
    defaultMessage: `image(s)`,
  },
  REPORT_DAMS_FIRST: {
    id: 'REPORT_DAMS_FIRST',
    defaultMessage: `Please click "update" to save changes first.`,
  },
  UPLOAD_BTN_GALLERY: {
    id: 'UPLOAD_BTN_GALLERY',
    defaultMessage: `Upload`,
  },
  PAVE_DELETE_BTN: {
    id: 'PAVE_DELETE_BTN',
    defaultMessage: `Delete`,
  },
  PAVE_DELETE_BTN_ALL: {
    id: 'PAVE_DELETE_BTN_ALL',
    defaultMessage: `Delete All`,
  },
  PAVE_HARD_WORING: {
    id: 'PAVE_HARD_WORING',
    defaultMessage: `PAVE Is Working Hard. One Moment Please.`,
  },
  PAVE_CLICK_ADD_DAMS: {
    id: 'PAVE_CLICK_ADD_DAMS',
    defaultMessage: `You Can Click To Add Damages`,
  },
  PAVE_USERS_ADD_DAMS: {
    id: 'PAVE_USERS_ADD_DAMS',
    defaultMessage: `User Added Damages`,
  },
  PAVE_ONLINE_BACK: {
    id: 'PAVE_ONLINE_BACK',
    defaultMessage: `Back Online`,
  },
  PAVE_LOST_CONNECTION: {
    id: 'PAVE_LOST_CONNECTION',
    defaultMessage: `You have lost your connection, try to move the vehicle to a better location and continue. Or you also can continue and reconnect later to finalize your capture.`,
  },
  PAVE_WEAK_CONNECTION: {
    id: 'PAVE_WEAK_CONNECTION',
    defaultMessage: `Weak connection, Move vehicle to better location and click here to continue.`,
  },
  PAVE_PROCESS_MESSAGE: {
    id: 'PAVE_PROCESS_MESSAGE',
    defaultMessage: `Please wait while results are being loaded to your device.`,
  },
  PAVE_PROCESS_MESSAGE_OFFLINE: {
    id: 'PAVE_PROCESS_MESSAGE_OFFLINE',
    defaultMessage: `You are still offline. Please reconnect to allow your photos to upload automatically.`,
  },
  PAVE_PROCESS_MESSAGE_CONNECTION_NETWORK: {
    id: 'PAVE_PROCESS_MESSAGE_CONNECTION_NETWORK',
    defaultMessage: `Weak connection, Move your phone to better location and continue.`,
  },
  PAVE_PROCESS_LOADING_BTN: {
    id: 'PAVE_PROCESS_LOADING_BTN',
    defaultMessage: `loading`,
  },
  PAVE_VIN_PLACEHOLDER: {
    id: 'PAVE_VIN_PLACEHOLDER',
    defaultMessage: `enter your vin`,
  },
  PAVE_VIN_PIN_SERIAL_PLACEHOLDER: {
    id: 'PAVE_VIN_PIN_SERIAL_PLACEHOLDER',
    defaultMessage: `enter your vin, pin or serial`,
  },
  PAVE_UPLOAD_MESS_FAIL: {
    id: 'PAVE_UPLOAD_MESS_FAIL',
    defaultMessage: `Photo upload failed . Please check your connection and try again`,
  },
  PAVE_DAMS_GROUP_TITLE: {
    id: 'PAVE_DAMS_GROUP_TITLE',
    defaultMessage: `interior`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_1: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_1',
    defaultMessage: `info`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_2: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_2',
    defaultMessage: `severe`,
  },
  CONFIRM_DAMAGE_COMPNENT: {
    id: 'CONFIRM_DAMAGE_COMPNENT',
    defaultMessage: `Component`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_4: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_4',
    defaultMessage: `Damage Type`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_4_1: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_4_1',
    defaultMessage: `cropped photo`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_5: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_5',
    defaultMessage: `Severity`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_6: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_6',
    defaultMessage: `Repair Method`,
  },
  PAVE_DAMS_GROUP_TITLE_SUB_7: {
    id: 'PAVE_DAMS_GROUP_TITLE_SUB_7',
    defaultMessage: `Check Box`,
  },
  PAVE_DAMS_GROUP_TITLE_1: {
    id: 'PAVE_DAMS_GROUP_TITLE_1',
    defaultMessage: `left view`,
  },
  LABEL_6: {
    id: 'LABEL_6',
    defaultMessage: `front view`,
  },
  PAVE_DAMS_GROUP_TITLE_3: {
    id: 'PAVE_DAMS_GROUP_TITLE_3',
    defaultMessage: `right view`,
  },
  PAVE_DAMS_GROUP_TITLE_4: {
    id: 'PAVE_DAMS_GROUP_TITLE_4',
    defaultMessage: `rear view`,
  },
  PAVE_DAMS_GROUP_TITLE_5: {
    id: 'PAVE_DAMS_GROUP_TITLE_5',
    defaultMessage: `WindShield`,
  },
  PAVE_DAMS_GROUP_TITLE_6: {
    id: 'PAVE_DAMS_GROUP_TITLE_6',
    defaultMessage: `tire & wheels`,
  },
  PAVE_DAMS_GROUP_TITLE_6_SUB_1: {
    id: 'PAVE_DAMS_GROUP_TITLE_6_SUB_1',
    defaultMessage: `Like New`,
  },
  PAVE_DAMS_GROUP_TITLE_6_SUB_2: {
    id: 'PAVE_DAMS_GROUP_TITLE_6_SUB_2',
    defaultMessage: `Good Condition`,
  },
  PAVE_DAMS_GROUP_TITLE_6_SUB_3: {
    id: 'PAVE_DAMS_GROUP_TITLE_6_SUB_3',
    defaultMessage: `Medium Worn`,
  },
  PAVE_DAMS_GROUP_TITLE_6_SUB_4: {
    id: 'PAVE_DAMS_GROUP_TITLE_6_SUB_4',
    defaultMessage: `Major Worn`,
  },
  PAVE_DAMS_GROUP_TITLE_6_SUB_5: {
    id: 'PAVE_DAMS_GROUP_TITLE_6_SUB_5',
    defaultMessage: `Snow Tire`,
  },
  PAVE_DAMS_SELECT_PLACE_HOLDER: {
    id: 'PAVE_DAMS_SELECT_PLACE_HOLDER',
    defaultMessage: `Choose damage types`,
  },
  PAVE_ACTION_SWITCH_LANGS_LOADING: {
    id: 'PAVE_ACTION_SWITCH_LANGS_LOADING',
    defaultMessage: `Action in progress..`,
  },
  PAVE_ACTION_SWITCH_LANGS_SUCCESS: {
    id: 'PAVE_ACTION_SWITCH_LANGS_SUCCESS',
    defaultMessage: `Success !`,
  },
  PAVE_EDIT_BTN_DMG: {
    id: 'PAVE_EDIT_BTN_DMG',
    defaultMessage: `edit`,
  },
  PAVE_SESSION_KEY_DOESNOT_EXIST: {
    id: 'PAVE_SESSION_KEY_DOESNOT_EXIST',
    defaultMessage: `Session key does not exist`,
  },
  PAVE_SESSION_KEY_EXPIRED: {
    id: 'PAVE_SESSION_KEY_EXPIRED',
    defaultMessage: `This session has expired. Please contact {name} for more information.`,
  },
  PAVE_SESSION_KEY_INVALID: {
    id: 'PAVE_SESSION_KEY_INVALID',
    defaultMessage: `This session is invalid. Please conduct another new inspection for this vehicle.`,
  },
  PAVE_CAMERA_ERROR: {
    id: 'PAVE_CAMERA_ERROR',
    defaultMessage: `Your camera was disabled, please follow HOW IT WORKS below to enable it`,
  },
  PAVE_WARNING_MESSAGES: {
    id: 'PAVE_WARNING_MESSAGES',
    defaultMessage: `Please be advised that through the self-return/inspection process you agree that use of the vehicle is hereby restricted to returning the vehicle to your local Dealership, when and if permissible by law. Should vehicle usage extend beyond this restriction, you may be required to pay additional monthly lease payments. 
		`,
  },
  PAVE_INSTRUCTION_SETTING: {
    id: 'PAVE_INSTRUCTION_SETTING',
    defaultMessage: `Initializing setting your session`,
  },
  VIN_DECODE_SUCCESS: {
    id: 'VIN_DECODE_SUCCESS',
    defaultMessage: `VIN decoded successfully`,
  },
  METHOD_VIN_INPUT: {
    id: 'METHOD_VIN_INPUT',
    defaultMessage: `input vin manually`,
  },
  METHOD_VIN_SCAN_QR: {
    id: 'METHOD_VIN_SCAN_QR',
    defaultMessage: `scan qr code`,
  },
  METHOD_VIN_SCAN_BARCODE: {
    id: 'METHOD_VIN_SCAN_BARCODE',
    defaultMessage: `scan barcode`,
  },
  METHOD_VIN_CAPTURE: {
    id: 'METHOD_VIN_CAPTURE',
    defaultMessage: `capture photo of vin`,
  },
  FRONT_BUMPER: {
    id: 'FRONT_BUMPER',
    defaultMessage: `Front Bumper`,
  },
  RIGHT_REAR_FENDER: {
    id: 'RIGHT_REAR_FENDER',
    defaultMessage: `Right Rear Quarter Panel`,
  },
  LEFT_REAR_FENDER: {
    id: 'LEFT_REAR_FENDER',
    defaultMessage: `Left Rear Quarter Panel`,
  },
  SMS_INPUT_PHONE_NUMBER: {
    id: 'SMS_INPUT_PHONE_NUMBER',
    defaultMessage: `Please input your phone number!`,
  },
  SMS_WHEN_READY: {
    id: 'SMS_WHEN_READY',
    defaultMessage: `We will send you an SMS message when your report is ready.`,
  },
  SMS_CORRECTLY: {
    id: 'SMS_CORRECTLY',
    defaultMessage: `Please input your phone number correctly.`,
  },
  OOPS_OVERLOAD_TRAFFIC: {
    id: 'OOPS_OVERLOAD_TRAFFIC',
    defaultMessage: `Oops, our SMS Server is not responding at this time. Please don't close your PAVE session. We will redirect you shortly. Sorry for the inconvenience.￼`,
  },
  WAITTING_GENERATE_ANNOTATED: {
    id: 'WAITTING_GENERATE_ANNOTATED',
    defaultMessage: `Please wait a moment while new annotated images are getting generated.`,
  },
  WATTING_A_MITUTE: {
    id: 'WATTING_A_MITUTE',
    defaultMessage: `Please wait for a moment. Or hit refresh to continue.`,
  },
  UPDATE_EXTERIOR_FIRST: {
    id: 'UPDATE_EXTERIOR_FIRST',
    defaultMessage: `Please click "Update" to save your changes before editing the tires.`,
  },
  VIN_ERROR_DECODE: {
    id: 'VIN_ERROR_DECODE',
    defaultMessage: `VIN Invalid: Not decodable`,
  },
  BACK_ONLINE_TRANSPHOTOS: {
    id: 'BACK_ONLINE_TRANSPHOTOS',
    defaultMessage: `Now that you are back online, please wait a moment as your images are getting transferred`,
  },
  OFFLINE_PROCESS_SENT: {
    id: 'OFFLINE_PROCESS_SENT',
    defaultMessage: `Sent`,
  },
  OFFLINE_PROCESS_TRANSFERRING: {
    id: 'OFFLINE_PROCESS_TRANSFERRING',
    defaultMessage: `Transferring`,
  },
  OFFLINE_PROCESS_WATTING: {
    id: 'OFFLINE_PROCESS_WATTING',
    defaultMessage: `Waiting`,
  },
  OFFLINE_PROCESS_MISSING: {
    id: 'OFFLINE_PROCESS_MISSING',
    defaultMessage: `missing`,
  },
  OFFLINE_PROCESS_STATUS: {
    id: 'OFFLINE_PROCESS_STATUS',
    defaultMessage: `status`,
  },
  VIN_CAPTION_SELECTED_OPTION: {
    id: 'VIN_CAPTION_SELECTED_OPTION',
    defaultMessage: `Select the best method to capture the vehicle's VIN`,
  },
  PAVE_ANT_NOTIFICATION: {
    id: 'PAVE_ANT_NOTIFICATION',
    defaultMessage: `Notification`,
  },
  LIST_DAMAGES_USER_ADD_DAMAGES: {
    id: 'LIST_DAMAGES_USER_ADD_DAMAGES',
    defaultMessage: `list damages`,
  },
  INVALID_VIN_EXCEEDED: {
    id: 'INVALID_VIN_EXCEEDED',
    defaultMessage: `You have already reached the limit of 4 inspections on this VIN for this month. Please try again next month.`,
  },
  VIN: {
    id: 'VIN',
    defaultMessage: 'VIN',
  },
  QR: {
    id: 'QR',
    defaultMessage: 'QR',
  },
  TOGGLE_DESC_VIN: {
    id: 'TOGGLE_DESC_VIN',
    defaultMessage: 'Toggle to VIN Photo Mode',
  },
  TOGGLE_DESC_QR: {
    id: 'TOGGLE_DESC_QR',
    defaultMessage: 'Toggle to VIN QR Code Mode',
  },
  QR_TITLE: {
    id: 'QR_TITLE',
    defaultMessage: "Scan VIN's QR Code",
  },
  QR_DESC: {
    id: 'QR_DESC',
    defaultMessage:
      "Place the vehicle's QR Code for the VIN within the viewfinder to automatically scan.",
  },
  CANNOT_SCAN_QR_CODE: {
    id: 'CANNOT_SCAN_QR_CODE',
    defaultMessage: `Cannot scan QR code. Capture a photo of VIN to proceed`,
  },
});
export default translationsUI;
